/** Installs only on supported secure origins; an ordinary HTTP phone visit keeps working. */
export function registerOfflineShell(){
 if(!window.isSecureContext||!('serviceWorker' in navigator)||!import.meta.env.PROD)return;
 // No forced reload, skipWaiting or private response caching.
 void navigator.serviceWorker.register(import.meta.env.BASE_URL+'offline-shell.js',{
  scope:import.meta.env.BASE_URL,updateViaCache:'none',
 }).catch(()=>{/* The online workspace remains usable if installation is unavailable. */});
}
